module.exports = __webpack_public_path__ + "img/grad1.197aef64.jpg";